import dayjs from 'dayjs';
import React, { FC } from 'react';
import { Form } from 'react-bootstrap';
import { LinkResponseDto } from '../../../store/landscapeAPI/link/dto/response/link-response.dto';
import { Button, RadioButton, ValidationForm } from '../../atoms';
import styles from './LandscapeIndicatorExternalResourceForm.module.css';

interface LandscapeIndicatorExternalResourceFormProps {
  externalResource: LinkResponseDto;
  handleExternalResourceChange: (externalResource: LinkResponseDto) => void;
  handleSubmitExternalResource: (externalResource: LinkResponseDto) => void;
}

const LandscapeIndicatorExternalResourceForm: FC<
  LandscapeIndicatorExternalResourceFormProps
> = ({
  externalResource,
  handleExternalResourceChange,
  handleSubmitExternalResource,
}) => {
  const date = new Date(externalResource.date ?? '');
  const formattedDate = dayjs(date).format('YYYY-MM-DD');
  return (
    <div className={styles.wrapper}>
      <ValidationForm
        onSubmitCallback={() => {
          handleSubmitExternalResource(externalResource);
        }}
      >
        <Form.Group className="mb-3">
          <Form.Label>Link Title</Form.Label>
          <Form.Control
            required
            type="text"
            value={externalResource.title ?? ''}
            onChange={(e) => {
              handleExternalResourceChange({
                ...externalResource,
                title: e.target.value,
              });
            }}
          />
          <Form.Control.Feedback type="invalid">
            Please provide a valid title
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Link Description</Form.Label>
          <Form.Control
            type="text"
            value={externalResource.description ?? ''}
            onChange={(e) => {
              handleExternalResourceChange({
                ...externalResource,
                description: e.target.value,
              });
            }}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>URL</Form.Label>
          <Form.Control
            required
            value={externalResource.url ?? ''}
            type="text"
            onChange={(e) => {
              handleExternalResourceChange({
                ...externalResource,
                url: e.target.value,
              });
            }}
          />
          <Form.Control.Feedback type="invalid">
            Please provide a valid url
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Date</Form.Label>
          <Form.Control
            type="date"
            placeholder="Enter date"
            onChange={(e) =>
              handleExternalResourceChange({
                ...externalResource,
                date: e.target.value,
              })
            }
            value={formattedDate}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Is Published</Form.Label>
          <br />
          <RadioButton
            defaultChecked={externalResource.published}
            onChange={(checked) =>
              handleExternalResourceChange({
                ...externalResource,
                published: checked,
              })
            }
          />
        </Form.Group>
        <Button variant="dark" type="submit">
          Save
        </Button>
      </ValidationForm>
    </div>
  );
};

export default LandscapeIndicatorExternalResourceForm;
